"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RendererProviderDefault = void 0;
var renderer_react_1 = require("@moonpig/renderer-react");
var react_1 = __importStar(require("react"));
var install_font_1 = require("./install-font");
var use_text_services_1 = require("./use-text-services");
var RendererProviderDefault = function (_a) {
    var children = _a.children;
    var textServicesResult = (0, use_text_services_1.useTextServices)();
    var getState = (0, react_1.useCallback)(function () {
        if (textServicesResult.error) {
            return { type: 'ERROR', message: textServicesResult.error.message };
        }
        if (textServicesResult.value) {
            return { type: 'LOADED' };
        }
        return { type: 'LOADING' };
    }, [textServicesResult]);
    var renderSceneSurface = (0, react_1.useCallback)(function (props) { return react_1.default.createElement(renderer_react_1.SceneSurfaceCanvas, __assign({}, props)); }, []);
    var resourceContext = (0, react_1.useMemo)(function () {
        return (0, renderer_react_1.createResourceContext)({
            loadFont: function (fontUrl) { return __awaiter(void 0, void 0, void 0, function () {
                var fontBytes, textServices, fontData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, renderer_react_1.loadFont)(fontUrl)];
                        case 1:
                            fontBytes = _a.sent();
                            return [4 /*yield*/, textServicesResult.promise];
                        case 2:
                            textServices = _a.sent();
                            return [4 /*yield*/, textServices.registerFont(fontBytes)];
                        case 3:
                            fontData = _a.sent();
                            return [4 /*yield*/, (0, install_font_1.installFont)(fontData)];
                        case 4:
                            _a.sent();
                            return [2 /*return*/, fontData];
                    }
                });
            }); },
            loadImage: renderer_react_1.loadImage,
        });
    }, []);
    var measureTextWidth = (0, react_1.useCallback)(function (input) {
        var textServices = textServicesResult.value;
        /* istanbul ignore next: guaranteed to be loaded at this point */
        if (!textServices) {
            throw new Error('Text services not loaded');
        }
        return textServices.measureTextWidth(input);
    }, [textServicesResult.value]);
    return (react_1.default.createElement(renderer_react_1.RendererProvider, { getState: getState, renderSceneSurface: renderSceneSurface, measureTextWidth: measureTextWidth, resourceContext: resourceContext }, children));
};
exports.RendererProviderDefault = RendererProviderDefault;
